export default __webpack_public_path__ + "static/media/joesriceroll.24db7dc5.jpeg";